import { render, staticRenderFns } from "./PurchaseDetailsTwo.vue?vue&type=template&id=abd82104&scoped=true&"
import script from "./PurchaseDetailsTwo.vue?vue&type=script&lang=js&"
export * from "./PurchaseDetailsTwo.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseDetailsTwo.vue?vue&type=style&index=0&id=abd82104&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abd82104",
  null
  
)

export default component.exports